<footer class="footer bg-light bg-white">
    <div class="container-fluid mt-3 mb-3">
        <img _ngcontent-bgc-c26="" class="me-3" src="assets/img/dcyf.jpg"  width="7%">Dirección de Contabilidad y Finanzas {{year}}.
    </div>
</footer>